import type { DrawingProps } from "./types";

/** A sheet with a folded corner and three written lines. */
export function Page({ size = 64, className, title }: DrawingProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      className={className}
      role={title ? "img" : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
    >
      <path
        d="M14 7h24l13 13v37a2 2 0 0 1-2 2H14a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2Z"
        fill="var(--white)"
        stroke="var(--ink)"
        strokeWidth="2.5"
        strokeLinejoin="round"
      />
      <path d="M38 7v13h13" fill="var(--sage)" stroke="var(--ink)" strokeWidth="2.5" strokeLinejoin="round" />
      <path d="M20 31h24M20 39h24M20 47h14" stroke="var(--sage-deep)" strokeWidth="2.5" strokeLinecap="round" />
    </svg>
  );
}
